import React from 'react'

export function InfoCircleIcon({ size = 16, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <circle cx="8" cy="8" r="6" />
      <line x1="8" y1="7.25" x2="8" y2="11.25" />
      <line x1="8" y1="5" x2="8" y2="5" />
    </svg>
  )
}
